(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaia-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('.shopify-section gaia-header');
    let announcementBar = document.querySelector('.utility-bar');

    const updateHeights = () => {
      document.documentElement.style.setProperty('--header-height', `${parseInt(header.offsetHeight)}px`);
      if (announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
      }
    };

    updateHeights();

    var headerObserver = new ResizeObserver(updateHeights);
    headerObserver.observe(header);

    if (announcementBar) {
      headerObserver.observe(announcementBar);
    }

    // Safari/iOS compatibility: Add class-based fallback for :has() selector
    // This ensures the header styling updates when menu opens on older Safari versions
    const mobileMenu = document.querySelector('gaia-mobile-menu');
    const searchDropdown = document.querySelector('.search-dropdown details');

    if (mobileMenu && header) {
      const mobileDetails = mobileMenu.querySelector('details');
      if (mobileDetails) {
        // Use MutationObserver to detect open attribute changes
        const menuObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
              if (mobileDetails.hasAttribute('open')) {
                header.classList.add('menu-is-open');
              } else {
                header.classList.remove('menu-is-open');
              }
            }
          });
        });

        menuObserver.observe(mobileDetails, { attributes: true });

        // Also listen for click events on summary as a backup
        const summary = mobileDetails.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', () => {
            // Delay to allow the open attribute to change
            setTimeout(() => {
              if (mobileDetails.hasAttribute('open')) {
                header.classList.add('menu-is-open');
              } else {
                header.classList.remove('menu-is-open');
              }
            }, 10);
          });
        }
      }
    }

    // Handle search dropdown open state
    if (searchDropdown && header) {
      const searchObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            if (searchDropdown.hasAttribute('open')) {
              header.classList.add('menu-is-open');
            } else if (!document.querySelector('gaia-mobile-menu details[open]')) {
              header.classList.remove('menu-is-open');
            }
          }
        });
      });

      searchObserver.observe(searchDropdown, { attributes: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
